import clsx from 'clsx';
import type { ReactNode } from 'react';
import { type ButtonProps as RACButtonProps, Button as RACButton } from 'react-aria-components';
import type { CommonProps, LabellableProps } from '../types.js';

interface TableHeaderButtonProps extends CommonProps, Omit<LabellableProps, 'label'>, Pick<RACButtonProps, 'onPress'> {
  /** The icon displayed within the button. */
  icon: ReactNode;
}

/**
 * @internal
 */
export function TableHeaderButton({ UNSAFE_className, UNSAFE_style, icon, ...props }: TableHeaderButtonProps) {
  return (
    <RACButton {...props} className={clsx('cim-table-header-button', UNSAFE_className)} style={UNSAFE_style}>
      {icon}
    </RACButton>
  );
}
